import { render, staticRenderFns } from "./ExternalBookingDisclaimerForm.vue?vue&type=template&id=044895aa&scoped=true"
import script from "./ExternalBookingDisclaimerForm.vue?vue&type=script&lang=js"
export * from "./ExternalBookingDisclaimerForm.vue?vue&type=script&lang=js"
import style0 from "./ExternalBookingDisclaimerForm.vue?vue&type=style&index=0&id=044895aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044895aa",
  null
  
)

export default component.exports